import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SendEmail } from "../api/Service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const EnterEmail = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const notifySuccess = (message) => {
        toast.success(message, {
          autoClose: 5000,
          style: {
            background: "#90EE90",
            color: "#000",
            fontWeight: "bold",
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
            borderRadius: "4px",
          }
        })
      }
    const handleSubmit = async(e) => {
        e.preventDefault();
        setLoading(true)
        try {
            let data = {
                email: email
            };
            console.log(data,'email2')

            const res = await SendEmail (data);
            if (res.status === 200) {
                setError(null);
                setLoading(false);
                notifySuccess("Email sent successfully Please Check Your Inbox");
            }
        } catch (err) {
            if(err){
                setLoading(false);
                console.log(err,'bhjfebferjk')
                setError(err.response.data.message);
            }else{
                setError(null)
            }
            
        }
    }

    return (
        <div className="flex justify-center items-center min-h-screen bg-[#f5f5f5] p-4 font-sans">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
                <div className="flex justify-center mb-8">
                    <h1 className="text-3xl font-bold text-[#121212]">AI Credit Repair</h1>
                </div>
                <h2 className="text-2xl font-semibold mb-6 text-center">Please Enter Your Email</h2>
                {error && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <input
                            type="email"
                            name="email"
                            placeholder="Email*"
                            className="w-full p-3 border border-gray-300 rounded"
                            value={email}
                            onChange={(e) => 
                                setEmail(e.target.value)
                            }
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full py-3 bg-gradient-to-r from-purple-500 to-red-500 text-white rounded-lg font-semibold hover:from-purple-600 hover:to-red-600"
                        disabled={loading}
                    >
                        {loading ? "Sending" : "Send Link"}
                    </button>
                </form>
                <div className="mt-6 text-center text-sm">
                    <a href="#" className="text-gray-600 hover:underline">
                        Remember Password? <Link to="/app/login">Login</Link>
                    </a>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}